var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoClean = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.60341C20 8.95256 19.7559 8.35595 19.2949 7.89494L16.9085 5.5085C15.9593 4.55934 14.4407 4.55934 13.4915 5.5085L5.78983 13.2102C4.84068 14.1593 4.84068 15.678 5.78983 16.6271L7.01017 17.8475H4.67797C4.29831 17.8475 4 18.1458 4 18.5254C4 18.9051 4.29831 19.2034 4.67797 19.2034H15.1186C15.4983 19.2034 15.7966 18.9051 15.7966 18.5254C15.7966 18.1458 15.4983 17.8475 15.1186 17.8475H12.7593L19.2949 11.3119C19.7559 10.8509 20 10.2271 20 9.60341ZM8.93559 17.8204L6.73898 15.6238C6.3322 15.217 6.3322 14.539 6.73898 14.1322L7.87797 12.9932L11.7559 16.8983L10.8068 17.8475H8.93559V17.8204Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoClean);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_clean.6835c6e76309860a380d934af7b952c7.svg";